export default __webpack_public_path__ + "static/media/morada.3aea79eb.svg";